/**
 * Path the Entity Providers settings sub-page is mounted at, which is also the
 * id of the tab the app's page layout hides from non-admins.
 */
export const ENTITY_PROVIDERS_SETTINGS_PATH = 'entity-providers';
